export default __webpack_public_path__ + "static/media/HelveticaNeueLT-Bold.d3d46c69.eot";